import React, { useState, useEffect } from "react";
import "./styles.css";
import axios from "axios";
import useAppData from "@/store/useAppData";
import useRouter from "@/store/useRouter";
import { useShallow } from "zustand/shallow";
import { RouterStoreItemKey } from "@/store/useRouter/types";
import logoAirlines from "./logoAirlines.png"
import { Module, Stock } from "../ItemList/types";
import Card from "../Card";
import { User } from "../UserSettings/types";
import FloatingActions, { FloatingAction } from "../FloatingActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { valueItem } from "../DeicingForm";

const SelectRoleOdmraz: React.FC = () => {

    const loggedUser = useAppData(state => state.user);
    const setLoggedUser = useAppData(state => state.setUser);
    const selectedModule = useAppData(state => state.selectedModule);
    const [stocksState, setStocksState] = React.useState<Stock[]>([]);
    const [selectedStockState, setSelectedStockState] = React.useState<Stock | null>(null);
    const [selectedRole, setSelectedRole] = React.useState<string | null>();
    const [userData, setUserData] = React.useState<User>();
    const [roles, setRoles] = React.useState<Map<string, string>>(new Map());
    const setSelectedStock = useAppData(state => state.setSelectedStock);
    const [usersState, setUsersState] = React.useState<valueItem[]>([]);
    const secondOperator = useAppData(state => state.secondOperator);
    const setSecondOperator = useAppData(state => state.setSecondOperator);
    const go = useRouter(state => state.go);

    const actions: FloatingAction[] = [
        {
            key: "1",
            label: "Vybrat",
            // icon: <FontAwesomeIcon icon={faArrowLeft} />,
            onClick: () => {

                if (selectedRole && (((selectedRole === "operator" || selectedRole === "kontrola") && selectedStockState) || (selectedRole != "operator" && selectedRole != "kontrola" && !selectedStockState))) {

                    selectedStockState && setSelectedStock(selectedStockState);
                    setLoggedUser({ ...loggedUser, id: loggedUser?.id!, name: loggedUser?.name!, name2: loggedUser?.name2!, userrole: selectedRole });
                    //setUserData({ ...loggedUser, id: loggedUser?.id!, userrole: selectedRole });
                    go({ key: RouterStoreItemKey.LISTITEMS });
                }
            }
        }
    ]

    useEffect(() => {
        // loadModules();
        const init = async () => {
            if (loggedUser) {

                const user = await loadUser(loggedUser.id);
                const loggedUserRoles = user.userrole.split("|");

                if (loggedUserRoles?.length === 1 && (loggedUserRoles[0] === "admin" || loggedUserRoles[0] === "backoffice" || loggedUserRoles[0] === "kontrola")) {
                    go({ key: RouterStoreItemKey.LISTITEMS });
                    return;
                }

                setRoles(new Map(loggedUserRoles.map(userRole => {
                    if (userRole === "admin") return ["admin", "Administrátor"]
                    else if (userRole === "backoffice") return ["backoffice", "BackOffice"]
                    else if (userRole === "kontrola") return ["kontrola", "Supervisor"]
                    else return ["operator", "Operátor"]
                })
                ));

                setSelectedRole(loggedUserRoles[0]);

                await loadStocks(loggedUserRoles[0]);

                await loadUsers();
            }
        };

        init();
    }, [loggedUser]);

    const loadUser = async (userId: string) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/appuser/get",
                    data: {
                        userId: userId
                    }
                })
            );

            if (res.data.user.length > 0) {
                return res.data.user[0];
            }

            return null;
        } catch (err) {
            throw err;
        }
    }

    const loadUsers = async () => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/appuser/getAllByModuleCode",
                    data: {
                        moduleCode: "ODMRAZ"
                    }
                })
            );

            setUsersState(res.data.users?.filter(user => user?.id != loggedUser?.id && user?.userrole?.includes("operator"))?.map(user => ({ value: user.id, label: user.name })));
        } catch (err) {
            throw err;
        }
    }

    const loadStocks = async (selectedRole: string) => {

        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/stock/getAll",
                    data: {
                        // userId: loggedUser?.id,
                        module: selectedModule?.id
                    }
                })
            );

            setStocksState(res.data.stocks || []);

            const availableStocks = res.data.stocks.filter(stock => !stock?.main);

            if (availableStocks.length > 0 && (selectedRole === "operator" || selectedRole === "kontrola")) {
                setSelectedStockState(availableStocks[0]);
            }

        } catch (err) {
            throw err;
        }
    }

    return (
        <Card
            title="Výběr role a vozidla"
            displaySelectedStock={false}
            displayLogo={false}
        >
            <div className="role-selection-form">
                <div className="role-selection-field">
                    <label htmlFor="role-select">
                        Oprávnění / Role
                    </label>

                    <select
                        id="role-select"
                        value={selectedRole ?? ""}
                        onChange={(e) => {
                            setSelectedRole(e.target.value);

                            const stocks = stocksState.filter(stock => !stock?.main);
                            if ((e.target.value === "operator" || e.target.value === "kontrola") && stocks?.length > 0) {
                                setSelectedStockState(stocks[0]);
                            } else {
                                setSecondOperator(null);
                            }
                        }}
                    >
                        {[...roles].map(([value, label]) => (
                            <option key={value} value={value}>
                                {label}
                            </option>
                        ))}
                    </select>
                </div>

                {selectedRole === "operator" && (
                    <div className="role-selection-field">
                        <label htmlFor="stock-select">
                            Vozidlo
                        </label>

                        <select
                            id="stock-select"
                            value={selectedStockState?.id ?? ""}
                            onChange={(e) => {
                                const stock = stocksState.find(
                                    stock => stock.id == e.target.value
                                );

                                setSelectedStockState(stock ?? null);

                                if (!stock?.twoOperators) {
                                    setSecondOperator(null);
                                }
                            }}
                        >
                            {stocksState
                                .filter(stock => !stock?.main)
                                .map(stock => (
                                    <option key={stock.id} value={stock.id}>
                                        {stock.name}
                                    </option>
                                ))}
                        </select>
                    </div>
                )}

                {selectedStockState?.twoOperators && selectedRole === "operator" && (
                    <div className="role-selection-field">
                        <label htmlFor="stock-select">
                            Druhý operátor
                        </label>

                        <select
                            id="stock-select"
                            value={secondOperator?.value ?? ""}
                            onChange={(e) => {
                                const operator = usersState.find(
                                    operator => operator.value == e.target.value
                                );

                                setSecondOperator(operator ?? null);
                            }}
                        >
                            <option value="">Vyberte operátora</option>
                            {usersState
                                .filter(user => user?.value != loggedUser?.id)
                                .map(user => (
                                    <option key={user.value} value={user.value}>
                                        {user.label}
                                    </option>
                                ))}
                        </select>
                    </div>
                )}
            </div>

            {actions?.length ? (
                <div className="item-list-actions">
                    <FloatingActions actions={actions} />
                </div>
            ) : null}
        </Card>
    );

    // return (
    //     <Card
    //         title="Výběr role a vozidla"
    //         displaySelectedStock={false}
    //     >
    //         <label>
    //             Oprávnění/Role
    //             <select
    //                 value={selectedRole ?? undefined}
    //                 onChange={(value) => setSelectedRole(value.target.value)}
    //             >
    //                 {
    //                     [...roles].map(([value, label]) =>
    //                     (<option key={value} value={value}>
    //                         {label}
    //                     </option>))
    //                 }
    //             </select>
    //         </label>

    //         {selectedRole === "operator" && <label>
    //             Vozidlo
    //             <select
    //                 value={selectedStockState?.id ?? ""}
    //                 onChange={(e) => {
    //                     const stock = stocksState.find(stock => stock.id == e.target.value);
    //                     setSelectedStockState(

    //                         stock ?? null
    //                     )
    //                 }}
    //             >
    //                 {
    //                     stocksState.filter(stock => !stock?.main).map(stock =>
    //                     (<option key={stock.id} value={stock.id}>
    //                         {stock.name}
    //                     </option>))
    //                 }
    //             </select>
    //         </label>}

    //         {
    //             actions?.length ? (
    //                 <div className="item-list-actions">
    //                     <FloatingActions actions={actions} />
    //                 </div>
    //             ) : null
    //         }
    //         {/* {modulesState.map(module => <button
    //             type="button"
    //             className="select-module-button"
    //             onClick={() => {
    //                 setSelectedModule(module);
    //                 go({ key: RouterStoreItemKey.LISTITEMS });
    //             }}
    //         >
    //             {module?.name}
    //         </button>)
    //         } */}
    //     </Card>
    // );
};

export default SelectRoleOdmraz;